//
import React, { useEffect } from "react";
//component
import DetailSoundClone from "./detail_sound_clone";
import FormTextAreaClone from "component/form/form_textarea_clone";
import QuickSoundTool from "./quick_sound_tool";
import { CheckOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, message, Row, Tag } from "antd";
//redux
//selector
import {
  draftDialogDetailSelector,
  draftDialogIndexSelector,
} from "store/bailiff/task/dialog/draft_dialog.selector";
//actions
import { setDraftDialogSelectedRange } from "store/bailiff/task/dialog/draft_dialog.action";
//utils
//hook
import { useDialogUpdate } from "hook/draft/dialog/action/useDialogUpdate";
import { useResponsive } from "hook/useResponsive";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
//str

const DetailPreviewClone = () => {
  // -------------------------- VAR -----------------------------
  const [form] = Form?.useForm();
  const segment = Form?.useWatch("segment", form) || "";
  const { mobile } = useResponsive();
  const { loading, handleUpdateSegment } = useDialogUpdate();

  const rows = mobile ? 20 : 10;
  const title = mobile
    ? "Chỉnh sửa câu"
    : "Hãy chỉnh sửa đoạn văn dưới đây giống như bản ghi âm";
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const detail = useSelector(draftDialogDetailSelector);
  const index = useSelector(draftDialogIndexSelector);
  const sentences = detail?.sentences || [];
  const exist = sentences[index] || null;
  const text = exist?.text || null;
  const slot = exist?.slot;
  const isEnded = index === sentences?.length;
  const labelEnd = isEnded ? "Bạn đã hoàn thành nhiệm vụ" : "Sửa Hoàn Tất";

  // -------------------------- FUNCTION ------------------------
  const handleFinish = () => {
    form
      ?.validateFields()
      .then((values) => {
        const { segment } = values;
        if (!slot)
          return message.error("Lỗi dữ liệu! Xin vui lòng reload lại trang");
        const content = segment;
        return handleUpdateSegment({ content, slot });
      })
      .catch((err) => {
        console.log({ err });
      });
  };
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    form?.setFieldValue("segment", text);
  }, [form, text]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderTitle = () => {
    return (
      <Row gutter={[20, 10]}>
        <Col xl={18} lg={18} md={18} xs={12}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              flexWrap: "wrap",
            }}
          >
            <EditOutlined />
            {title}
          </div>
        </Col>
        <Col align="right" xl={6} lg={6} md={6} xs={12}>
          <Tag>
            Đã sửa: {segment?.length || 0} / {text?.length || 0}
          </Tag>
        </Col>
      </Row>
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <Card
      style={{ textAlign: "left" }}
      styles={{ body: { padding: mobile ? 0 : 24 } }}
      title={renderTitle()}
    >
      <Form id="detail-preview" form={form}>
        <Row gutter={[0, 0]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            {/* Đoạn Ghi */}
            <DetailSoundClone />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <FormTextAreaClone
              className="text-[18px] leading-[35px]"
              rules={[{ required: true, message: "Làm ơn không để trống" }]}
              name="segment"
              placeholder="Nhập câu chỉnh sửa..."
              variant={!mobile ? "outlined" : "underlined"}
              rows={rows}
              onSelect={(e) => {
                dispatch(
                  setDraftDialogSelectedRange({
                    start: e.target.selectionStart,
                    end: e.target.selectionEnd,
                  }),
                );
              }}
            />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <QuickSoundTool form={form} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <Button
              type="primary"
              className="min-h-[40px]"
              icon={<CheckOutlined style={{ color: "white" }} />}
              onClick={handleFinish}
              loading={loading}
              disabled={segment === "" || isEnded}
              block
            >
              {labelEnd}
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};
export default DetailPreviewClone;
